import(/* webpackMode: "eager" */ "/home/ubuntu/shoptrendz/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/shoptrendz/src/components/ClientProviders.tsx");
